<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/build' }">党建专栏</el-breadcrumb-item>
        <el-breadcrumb-item>党建详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>深刻把握“第二个结合”的精髓要义</h2>
        <p style="text-align: right"><span style="margin-right: 60px">2023-06-04</span></p>
        <p>
          <strong>新华社北京6月4日电题：深刻把握“第二个结合”的精髓要义——二论学习贯彻习近平总书记在文化传承发展座谈会上的重要讲话精神!</strong>
        </p>
        <p>
          新华社评论员:
        </p>
        <p>
          “‘第二个结合’，是我们党对马克思主义中国化时代化历史经验的深刻总结，是对中华文明发展规律的深刻把握”。在文化传承发展座谈会上的重要讲话中，习近平总书记深刻揭示“两个结合”的重大意义，深入阐明“第二个结合”的精髓要义，进一步拓展和深化了我们党对推进马克思主义中国化时代化的规律性认识，为在新的历史起点上不断推进党的理论创新提供了科学指引。
        </p>
        <p>
          根深才能叶茂，本固才会枝荣。在5000多年中华文明深厚基础上开辟和发展中国特色社会主义，把马克思主义基本原理同中国具体实际、同中华优秀传统文化相结合是必由之路。这是我们在探索中国特色社会主义道路中得出的规律性的认识，是我们取得成功的最大法宝。“第二个结合”，表明我们党对中国道路、理论、制度的认识达到了新高度，表明我们党的历史自信、文化自信达到了新高度，表明我们党在传承中华优秀传统文化中推进文化创新的自觉性达到了新高度。
        </p>
        <p>
          “结合”的前提是彼此契合。马克思主义和中华优秀传统文化来源不同，但彼此存在高度的契合性。相互契合才能有机结合。马克思主义传入中国后，科学社会主义的主张受到中国人民热烈欢迎，并最终扎根中国大地、开花结果，决不是偶然的，而是同我国传承了几千年的优秀历史文化和广大人民日用而不觉的价值观念融通的。把马克思主义思想精髓同中华优秀传统文化精华贯通起来、同人民群众的共同价值观念融通起来，不断赋予科学理论鲜明的中国特色，就能不断夯实马克思主义中国化时代化的历史基础和群众基础，让马克思主义在中国牢牢扎根。
        </p>
        <p>
          马克思主义深刻改变了中国，中国也极大丰富了马克思主义。“结合”不是拼盘，不是简单的物理反应，而是深刻的化学反应。“结合”的结果是互相成就，造就了一个有机统一的新的文化生命体，让马克思主义成为中国的，中华优秀传统文化成为现代的，让经由“结合”而形成的新文化成为中国式现代化的文化形态。
        </p>
        <p>
          中国特色社会主义道路，是在马克思主义指导下走出来的，也是从5000多年中华文明史中走出来的。“结合”筑牢了道路根基，让中国特色社会主义道路有了更加宏阔深远的历史纵深，拓展了中国特色社会主义道路的文化根基。中国式现代化是赓续古老文明的现代化，而不是消灭古老文明的现代化；是从中华大地长出来的现代化，不是照搬照抄其他国家的现代化；是文明更新的结果，而不是文明断裂的产物。中国式现代化赋予中华文明以现代力量，中华文明赋予中国式现代化以深厚底蕴。
        </p>
        <p>
          “结合”打开了创新空间，让我们掌握了思想和文化主动，并有力地作用于道路、理论和制度。中国共产党为什么能，中国特色社会主义为什么好，归根到底是马克思主义行，是中国化时代化的马克思主义行。
          “第二个结合”是又一次的思想解放，让我们能够在更广阔的文化空间中，充分运用中华优秀传统文化的宝贵资源，探索面向未来的理论和制度创新。
        </p>
        <p>
          中华优秀传统文化是中华民族的根和魂。“结合”巩固了文化主体性，创立习近平新时代中国特色社会主义思想就是这一文化主体性的最有力体现。习近平新时代中国特色社会主义思想坚持把马克思主义基本原理同中国具体实际相结合、同中华优秀传统文化相结合，既立足于现实的中国，又植根于历史的中国，具有强大的历史穿透力、文化感染力、精神感召力，是当代中国马克思主义、二十一世纪马克思主义，是中华文化和中国精神的时代精华，实现了马克思主义中国化时代化新的飞跃，为新时代党和国家事业发展提供了根本遵循。
        </p>
        <p>
          实践没有止境，理论创新也没有止境。在强国建设、民族复兴的新征程上，让我们更加深刻领悟“两个确立”的决定性意义，增强“四个意识”、坚定“四个自信”、做到“两个维护”，继续推进实践基础上的理论创新，不断谱写马克思主义中国化时代化新篇章。
        </p>
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({ name: 'Build8' })">&lt;
            上一条&nbsp;&nbsp;&nbsp;&nbsp;又踏层峰辟新天——《中共中央关于...</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" style="text-align: right" class="hidden-xs-only">
          <span style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'Build6' })">二十大精神关键词解读...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span>
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.kongxi {
  height: 10px;
}

.content {
  width: 90%;
  margin: 0 auto;

  h2 {
    font-family: 黑体, SimHei;
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }

  p {
    font-size: 16px;
    margin: 20px 0;
    text-align: justify;
    text-indent: 2em;
    color: #515050;
    font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
  }
}

@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      font-family: 黑体, SimHei;
      font-size: 24px;
      margin: 20px 0;
      text-align: center;
    }

    p {
      font-size: 16px;
      margin: 20px 0;
      text-align: justify;
      text-indent: 2em;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
}
</style>